import { render, staticRenderFns } from "./AppCardTitle.vue?vue&type=template&id=dca37420&scoped=true&lang=pug&"
import script from "./AppCardTitle.vue?vue&type=script&lang=js&"
export * from "./AppCardTitle.vue?vue&type=script&lang=js&"
import style0 from "./AppCardTitle.vue?vue&type=style&index=0&id=dca37420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca37420",
  null
  
)

export default component.exports